import { useEffect } from 'react';
import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { Action } from 'redux-saga';

import { useBusiness } from '../../../store/business';
import { getMessageInError } from '../../../hooks/fetch';
import {
  businessById,
  businessByIdClear,
  businessByIdErrorClear,
  BusinessByIdParams,
} from '../../../store/business/byId';

export const useBusinessById = () => {
  const dispatch = useDispatch();
  const { byId } = useBusiness();

  const getBusinessById = (params: BusinessByIdParams) => {
    dispatch(businessById(params) as Action);
  };

  useEffect(() => () => {
    dispatch(businessByIdClear() as Action);
    dispatch(businessByIdErrorClear() as Action);
  }, []);

  useEffect(() => {
    if (byId.error) {
      message
        .error(getMessageInError(byId.error))
        .then(() => dispatch(businessByIdErrorClear() as Action));
    }
  }, [byId.error]);

  const clearBusinessById = () => {
    dispatch(businessByIdClear() as Action);
    dispatch(businessByIdErrorClear() as Action);
  };

  return {
    getBusinessById, clearBusinessById, response: byId.response, error: byId.error, loading: byId.loading,
  };
};
